
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m12 22.5c5.799 0 10.5-4.701 10.5-10.5 0-5.79899-4.701-10.5-10.5-10.5-5.79899 0-10.5 4.70101-10.5 10.5 0 5.799 4.70101 10.5 10.5 10.5zm3.2815-14.87505-3.2814 3.28135-3.28127-3.28135c-.30203-.30204-.79172-.30204-1.09375 0-.30203.30203-.30203.79171 0 1.09374l3.28132 3.28131-3.28118 3.2812c-.30203.302-.30203.7917 0 1.0937.30203.3021.79172.3021 1.09375 0l3.28113-3.2811 3.2812 3.2811c.3021.3021.7918.3021 1.0938 0 .302-.302.302-.7917 0-1.0937l-3.2812-3.2812 3.2813-3.28131c.302-.30203.302-.79171 0-1.09374s-.7917-.30203-1.0937 0z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    